import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { ToggleButton, ToggleButtonGroup as RBToggleButtonGroup } from 'react-bootstrap'
import styles from './ToggleButtonGroup.module.scss'

const getButtonVariant = ({ variant, option, value }) => {
  if (variant === 'engage' || variant === 'primary') {
    return value === option.value ? 'primary' : 'secondary'
  }

  return variant
}

const SIZE_CLASS = {
  md: styles.toggleButtonMedium,
  lg: styles.toggleButtonLarge,
}

const propTypes = {
  /**
   * id (name) of the radio group
   */
  id: PropTypes.string.isRequired,
  /**
   * options of the radio group
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string, // option value needs to be an string!
    }),
  ).isRequired,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Selected value
   */
  value: PropTypes.string,
  /**
   * Button group style
   */
  variant: PropTypes.oneOf(['engage', 'primary']), // right now only these style variants are supported
  /**
   * Size of the button
   */
  size: PropTypes.oneOf(['md', 'lg']),
}

function ToggleButtonGroup(props) {
  const { id, options, onChange, value = null, variant = 'primary', size = 'md' } = props ?? {}

  return (
    <RBToggleButtonGroup
      type="radio"
      name={id ?? 'toggle-button-group'}
      value={value ?? undefined}
      onChange={(nextValue) => onChange(nextValue)}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          id={`${id}-${option.value}`}
          value={option.value}
          variant={getButtonVariant({ variant, option, value })}
          className={clsx(
            SIZE_CLASS[size],
            variant === 'engage' && value === option.value ? 'btn-engage' : '',
            variant === 'engage' && value !== option.value ? 'text-color-engage' : '',
            variant === 'primary' && value !== option.value ? 'text-color-primary' : '',
          )}
        >
          {option.label}
        </ToggleButton>
      ))}
    </RBToggleButtonGroup>
  )
}

ToggleButtonGroup.propTypes = propTypes

export default ToggleButtonGroup
